import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";
import {BlackoutDateProps} from "../types/BlackoutPeriod";

export const DeactivateFlow = async (domain: string, flowId: number): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `flows/${flowId}/deactivate-flow`,
        method: 'PATCH',
        headers: {
            "Content-Type": "application/json",
        },
        domain,
    });
}